import { useOutletContext } from "react-router";
import type { Site } from "@baze/api-client";

export interface SiteOutletContext {
  site: Site;
}
/** Industries whose sites are invitations: they get the personal guest-link tool (Kirim undangan). */
export const INVITATION_INDUSTRIES: ReadonlySet<string> = new Set(["wedding-invitation", "birthday"]);
/** Industries whose sites may collect wishes and RSVPs (tab Ucapan & RSVP): invitations and events. */
export const EVENT_INDUSTRIES: ReadonlySet<string> = new Set([...INVITATION_INDUSTRIES, "event-organizer"]);

export const useSiteOutlet = () => useOutletContext<SiteOutletContext>();
